export const JSON_ONE = {
   
    "ag_id": "Paygate",
    "me_id": "202106080001",
    "order_no": "mdjy9spYJzaNNxRBVd9v2FJGBiitdzKyZCcg6rHp65M=",
    "ag_ref": "raaP4NFj4mZIFBxoRG8zHA=="
    }



